module.exports = __webpack_public_path__ + "static/media/ic_hs_b5_myway.60e7f0a1.svg";